module.exports = __webpack_public_path__ + "static/Netflix-5880b97f932178c76478d99881a3b5cd.png";